module.exports = __webpack_public_path__ + "img/totalsites.015ccc40.png";